module.exports = __webpack_public_path__ + "img/page1.52956842.png";